
















import { Component, Prop, Vue } from 'vue-property-decorator'
import List from './List.vue'
import gql from 'graphql-tag'

@Component({
  components: {
    List
  }
})
export default class Seeds extends Vue {
  @Prop() private msg!: string;
  seedsQuery = gql`query {
    seeds {
      id,
      name,
      description
    }
  }`;

  async createNew (payload) {
    payload.description = 'description for ' + payload.name
    await this.$apollo.mutate({
      mutation: gql`mutation ($name: String!, $description: String!) {
        addSeed(name: $name, description: $description) {
          id
          name,
          description
        }
      }`,
      variables: {
        ...payload
      },
      update: (cache, { data: { addSeed } }) => {
        const data = cache.readQuery({ query: this.seedsQuery })
        data['seeds'].push(addSeed)
        cache.writeQuery({ query: this.seedsQuery, data })
      }
    })
  }

  async deleteItem (payload) {
    await this.$apollo.mutate({
      mutation: gql`mutation ($id: Int!) {
        deleteSeed(id: $id) {
          id
        }
      }`,
      variables: {
        id: payload.id
      },
      update: (cache, { data: { deleteSeed } }) => {
        const data = cache.readQuery({ query: this.seedsQuery })
        data['seeds'] = data['seeds'].filter(seed => seed.id !== deleteSeed.id)
        cache.writeQuery({ query: this.seedsQuery, data })
      }
    })
  }
}
